import { render, staticRenderFns } from "./GekkoButton.vue?vue&type=template&id=7c9d0db8&scoped=true&"
import script from "./GekkoButton.vue?vue&type=script&lang=js&"
export * from "./GekkoButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c9d0db8",
  null
  
)

export default component.exports